import { gql } from "@apollo/client";export default gql`query tabAggregate($where: home_explore_tab_bool_exp) {
    tabAggregate: home_explore_tab_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
